<template>
  <path d="M7.08,4.89,9.49,2.53,18.92,12,9.49,21.47,7.08,19.11,14.18,12Z" />
</template>

<script>
export default {
  name: 'Icon' + 'Arrow'
};
</script>
